// extracted by mini-css-extract-plugin
export default {"FAQ":"FAQ_FAQ__Tt3YH","FAQ__title":"FAQ_FAQ__title__ljlIi","FAQ__btnCont":"FAQ_FAQ__btnCont__I43I8"};